<div class="clients-search" data-test-id="filter-clients">
  <app-typeahead-multiselect
    [fetchItems]="getClientsCallback()"
    [keyProperty]="keyProperty"
    [valueProperty]="valueProperty"
    [selectedItems]="selectedItems"
    (selectedItemsChanged)="onClientChange($event)"
    [isSingleSelect]="isSingleSelect"
    customPlaceholderText="Search clients"
  ></app-typeahead-multiselect>
</div>
